/**
 * KeyboardFocusVisible
 *
 * Accesibilidad (WCAG 2.1 AA - 2.4.7 Foco visible):
 * el indicador de foco debe verse al navegar con teclado, pero no al interactuar
 * con el ratón.
 *
 * Estrategia:
 * - Al pulsar Tab se añade la clase 'user-is-tabbing' a <body>.
 * - En cuanto se usa el ratón (mousedown) se retira.
 * - El CSS (overrides.scss) solo pinta el foco cuando esa clase está presente:
 *     .user-is-tabbing ... :focus { ... }
 *
 * Se alternan los listeners (solo hay uno activo a la vez) para minimizar el
 * trabajo por evento.
 *
 * Registro en main.js:
 *   import { initKeyboardFocusVisible } from '@/components/directives/KeyboardFocusVisible.js'
 *   initKeyboardFocusVisible()
 */

const TABBING_CLASS = 'user-is-tabbing'

function handleFirstTab (e) {
  if (e.key !== 'Tab') return
  document.body.classList.add(TABBING_CLASS)
  window.removeEventListener('keydown', handleFirstTab)
  window.addEventListener('mousedown', handleMouseDownOnce)
}

function handleMouseDownOnce () {
  document.body.classList.remove(TABBING_CLASS)
  window.removeEventListener('mousedown', handleMouseDownOnce)
  window.addEventListener('keydown', handleFirstTab)
}

export function initKeyboardFocusVisible () {
  window.addEventListener('keydown', handleFirstTab)
}
